import { render, staticRenderFns } from "./ItsApplyBill.vue?vue&type=template&id=889ea5a6&scoped=true&"
import script from "./ItsApplyBill.vue?vue&type=script&lang=js&"
export * from "./ItsApplyBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889ea5a6",
  null
  
)

export default component.exports